// The pre-need handoff rides its credential in the URL — a link token
// (`t`) or a signed lead payload (`ped`, `sig`, `exp`). Analytics reads the
// page's URL constantly ($current_url, referrers, the signal beacon's
// `dl`); none of those surfaces may carry a live credential off the page.

const CREDENTIAL_PARAMS = ["t", "ped", "sig", "exp"];

/**
 * Strips the handoff credential params from a URL string, leaving
 * everything else untouched. Malformed input passes through unchanged —
 * this feeds analytics pipes, and a throw here must never take one down.
 */
export function redactCredentialParams(url: string): string {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return url;
  }
  let changed = false;
  for (const key of CREDENTIAL_PARAMS) {
    if (parsed.searchParams.has(key)) {
      parsed.searchParams.delete(key);
      changed = true;
    }
  }
  return changed ? parsed.toString() : url;
}
